import { render, staticRenderFns } from "./PortalUsers_DELETE.vue?vue&type=template&id=7d15b7db&scoped=true"
import script from "./PortalUsers_DELETE.vue?vue&type=script&lang=js"
export * from "./PortalUsers_DELETE.vue?vue&type=script&lang=js"
import style0 from "./PortalUsers_DELETE.vue?vue&type=style&index=0&id=7d15b7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15b7db",
  null
  
)

export default component.exports